import React, { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

const FileViewerPage = () => {
    const { fileUrlEncoded, fileName } = useParams();
    const navigate = useNavigate();
    const startTimeRef = useRef(Date.now());

    const fileUrl = decodeURIComponent(fileUrlEncoded);
    const ext = fileName.split(".").pop()?.toLowerCase();

    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
    const isPDF = ext === "pdf";
    const isOffice = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(ext);

    const getViewerUrl = () => {
        if (isOffice) {
            return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
        } else if (isPDF) {
            return `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
        }
        return null;
    };

    useEffect(() => {
        return () => {
            const durationMs = Date.now() - startTimeRef.current;
            const seconds = Math.floor(durationMs / 1000);

            console.log(`User viewed "${fileName}" for ${seconds} seconds`);

            // Optional: send to backend
            /*
            fetch('/api/file-view-log', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    fileName,
                    fileUrl,
                    duration: seconds
                })
            });
            */
        };
    }, []);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
            <div className="relative w-11/12 max-w-5xl bg-white rounded shadow-lg">
                {/* Header */}
                <div className="flex justify-between items-center px-4 py-2 border-b">
                    <h2 className="text-md font-semibold truncate">{fileName}</h2>
                    <button
                        className="text-sm px-3 py-1 bg-red-500 text-white rounded"
                        onClick={() => navigate(-1)}
                    >
                        Close
                    </button>
                </div>

                {/* Viewer Area */}
                <div className="relative w-full h-[80vh] overflow-hidden">
                    {isImage ? (
                        <img
                            src={fileUrl}
                            alt={fileName}
                            className="w-full h-full object-contain pointer-events-none select-none"
                            onContextMenu={(e) => e.preventDefault()}
                        />
                    ) : (
                        <iframe
                            src={getViewerUrl()}
                            title={fileName}
                            sandbox="allow-scripts allow-same-origin allow-forms"
                            className="w-full h-full"
                        />
                    )}

                    {/* Watermark */}
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-30 z-10">
                        <span className="text-4xl font-bold text-red-500 rotate-45">CONFIDENTIAL</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FileViewerPage;
